import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, Input } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';

interface SelectableCustomerRow {
  ragioneSociale: string;
  isSelected: () => boolean;
  select: () => void;
}

@Component({
  providers: [provideTranslocoScope('orders')],
  selector: 'ord-customer-radio-cell',
  imports: [TranslocoPipe, MatRadioModule],
  template: `
    <mat-radio-button
      [checked]="itemData.isSelected()"
      [attr.aria-label]="(('orders.ui.seleziona' | transloco) + &quot; &quot;) + itemData.ragioneSociale"
      (click)="$event.stopPropagation()"
      (change)="itemData.select()"
    />
  `,
})
export class CustomerRadioCell {
  @Input({ required: true }) itemData!: SelectableCustomerRow;
  @Input() infoColumn: unknown;
  @Input() _reloadData?: { emit: () => void };
}
